<template>
	<div>
		<div class="header--section container compact-padding">
			<h1 class="heading--xl text-uppercase header--section__heading">
				NEVER MISS ANOTHER OPPORTUNITY
			</h1>
			<p class="paragraph">
				Even if we don’t have the ideal job for you today, tomorrow
				might be a different story! Sign up for job notifications
				tailored to your profile and receive new openings directly in
				your inbox!
			</p>
		</div>
		<SubscribeForm />
		<ScrollTopButton />
	</div>
</template>

<script>
import Hero from "../components/common/HerroConstructor";
import BasicButton from "../components/BasicButton";
// import UnsolicitedForm from "../components/applicationPageComponents/UnsolicitedForm";
// import ApplicationForm from "../components/applicationPageComponents/ApplicationForm";
import SubscribeForm from "../components/applicationPageComponents/SubscribeForm";

export default {
	name: "subscribe-component",
	components: {
		// UnsolicitedForm,
		Hero,
		BasicButton,
		SubscribeForm
		// ApplicationForm
	},
	mounted() {
		const scrollTopButton = document.getElementsByClassName(
			"top-button-container"
		);
		console.log(scrollTopButton.item(0).remove());
	},
	metaInfo() {
		return {
			title: "Subscribe for job notifications",
			htmlAttrs: {
				lang: "en",
				metaInfo: {
					meta: [
						{ charset: "utf-8" },
						{
							name: "og:title",
							content: "Subscribe for job notifications"
						},
						{
							name: "description",
							content: "Bohemia Interactive subscribe page"
						},
						{
							name: "og:image",
							content: "Bohemia Interactive subscribe page"
						},
						{ name: "og:type", content: "Subscribe page" }
					]
				}
			}
		};
	}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../assets/scss/globals";

#form {
	padding-bottom: 40px;
}

.header--section {
	padding: 5em;
	@media (max-width: $compact) {
		padding: 3em;
	}
}

.header--section__heading {
	margin-top: 62px;
	margin-bottom: 62px;
	@media (max-width: $compact) {
		margin-top: 10px;
		margin-bottom: 20px;
	}
}

.main-heading {
	text-transform: uppercase;
	font-size: 36px;
	font-weight: 800;
	letter-spacing: 0.72px;
	font-family: Montserrat, sans-serif;
	margin-top: 60px;
	margin-bottom: 40px;
}

.paragraph {
	font-family: "Inter UI", sans-serif;
	font-size: 16px;
	letter-spacing: 0.02px;
	line-height: 28px;
	font-weight: 400;
}

.sub-header {
	font-size: 35px;
	font-family: "Montserrat", sans-serif;
	margin-bottom: 45px;
	margin-top: 75px;
	font-weight: 300;
	letter-spacing: 0.19px;
	word-wrap: break-word;

	@media (max-width: $tablet) {
		font-size: 22px;
	}
}

.text {
	margin-top: 45px;
	word-wrap: break-word;
}

.button-wrapper {
	@media (max-width: $compact) {
		display: flex;
		justify-content: center;
		align-self: center;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/SubscribePage.vue